export const createLabel = name => ({
  id: name,
  name,
  isDisabled: true,
  isLabel: true,
});
